var GraphQLErrorCode;
(function (GraphQLErrorCode) {
    GraphQLErrorCode["Unauthenticated"] = "UNAUTHENTICATED";
})(GraphQLErrorCode || (GraphQLErrorCode = {}));
export default GraphQLErrorCode;
